import type { ContentProps } from '@workspace/core-ts/types';

export default {
    description: {
        site: [
            <p>
                Pour vous proposer un <em>devis personnalisé</em>, nous avons besoin de collecter des informations sur <em>votre société et votre flotte</em>.
            </p>,
            <p>Avant de commencer, munissez-vous des cartes grises de votre ou vos véhicules.</p>,
        ],
        conseiller: [
            <p>
                Pour vous proposer un <b>devis personnalisé</b>, nous avons besoin de collecter des informations sur <em>la société et la flotte de votre client.</em>
            </p>,
            <p>Avant de commencer, munissez-vous des cartes grises de son ou ses véhicules.</p>,
        ],
    },
} as unknown as ContentProps;
